import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { ErrorHandler, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgbAccordionModule, NgbModalModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxsModule } from '@ngxs/store';
import { Angulartics2Module } from 'angulartics2';
import { LoggerModule, NgxLoggerLevel } from 'ngx-logger';
import { ToastrModule } from 'ngx-toastr';
import { AccordionModule } from 'primeng/accordion';
import { environment } from '../environments/environment';
import { AppComponent } from './app.component';
import { AppConfig, appWindow } from './AppWindow';
import { AuthorizationModule } from './authorization/authorization.module';
import { CoreModule } from './core/core.module';
import { ErrorModalService } from './core/error-modal/error-modal-service';
import { ErrorModalComponent } from './core/error-modal/error-modal.component';
import { HttpErrorInterceptor } from './core/error/http-error-interceptor.service';
import { GlobalErrorHandler } from './core/global-error-handler/global-error-handler';
import { GlobalErrorHandlerModule } from './core/global-error-handler/global-error-handler.module';
import { FooterModule } from './footer/footer.module';
import { HeaderModule } from './header/header.module';
import { ProductsModalComponent } from './products/products-modal/products-modal.component';
import { AppRoutingModule } from './routing/app-routing.module';
import { UserTrackerService } from './user-tracker/user-tracker.service';
import { TranslocoRootModule } from './transloco-root.module';

@NgModule({
  declarations: [AppComponent, ErrorModalComponent, ProductsModalComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HeaderModule,
    FooterModule,
    HttpClientModule,
    NgbModalModule,
    NgxsModule.forRoot([], { developmentMode: !environment.production }),
    LoggerModule.forRoot({
      serverLoggingUrl: appWindow.portalConfig.sumoLogicURL,
      level: NgxLoggerLevel.DEBUG,
      serverLogLevel: NgxLoggerLevel.INFO,
      enableSourceMaps: true,
    }),
    Angulartics2Module.forRoot(),
    NgbAccordionModule,
    GlobalErrorHandlerModule,
    ToastrModule.forRoot({
      positionClass: 'toast-bottom-center',
      toastClass: 'ngx-toastr',
    }),
    BrowserAnimationsModule,
    CoreModule,
    AuthorizationModule.forRoot(),
    TranslocoRootModule,
    AccordionModule,
  ],
  providers: [
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
    { provide: AppConfig, useValue: appWindow.portalConfig },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpErrorInterceptor,
      multi: true,
    },
    ErrorModalService,
    UserTrackerService,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
